import styled from '@emotion/styled'
import { Link } from 'gatsby'

import { breakpoints } from '../../utils/styles'

export const Wrapper = styled.div`
  position:absolute;
  width: 100%;
  z-index: 9999;
  position: fixed;
  top: 0;
  background: whitesmoke;
  /* margin-bottom: 1rem; */
  border-bottom: 1px solid #f1f1f1;
  height: 60px;
  -webkit-box-shadow: 0 3px 4px -6px black;
    -moz-box-shadow: 0 3px 4px -6px black;
    box-shadow: 0 3px 4px -6px black;
`

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 1rem;
  padding-top: 1.5rem;
  margin: 0 auto;
  max-width: 1024px;
`

export const MenuLink = styled(Link)`
  color: #aaaaaa;
  text-decoration: none;
  font-size: 1.8rem;
  font-weight: bold;

  @media (max-width: ${breakpoints.s}px){
    font-size: 1.4rem
  }
`

export const CartCounter = styled.span`
  background-color: white;
  color: #663399;
  border-radius: 20px;
  padding: 0 10px;
  font-size: 1.2rem;
  float: right;
  margin: -10px;
  z-index: 20;
`






